module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mall-header'), _vm._v(" "), _c('div', {
    staticClass: "paysuc-div "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "span-payinfo-css"
  }, [(_vm.orderData.type == 1) ? _c('span', [_vm._v("支付方式：微信支付")]) : _vm._e(), _vm._v(" "), (_vm.orderData.type == 2) ? _c('span', [_vm._v("支付方式：支付宝")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("支付金额："), _c('label', {
    staticStyle: {
      "color": "rgb(255, 98, 13)"
    }
  }, [_vm._v("￥" + _vm._s(_vm.orderData.totalAmount))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("支付时间：" + _vm._s(_vm.orderData.updateTime))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block"
    }
  }, [_vm._v("订单编号：" + _vm._s(_vm.orderData.orderNo))])]), _vm._v(" "), _c('div', {
    staticClass: "el-button-div"
  }, [_c('el-button', {
    staticClass: "el-button-ok",
    on: {
      "click": _vm.openIndex
    }
  }, [_vm._v("进入首页")]), _vm._v(" "), _c('el-button', {
    staticClass: "el-button-cancel",
    on: {
      "click": _vm.viewOrder
    }
  }, [_vm._v("查看订单")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "height": "210px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0px",
      "bottom": "0px",
      "width": "100%",
      "z-index": "1",
      "text-align": "center",
      "padding": "20px 0",
      "color": "#999999",
      "font-size": "14px"
    }
  }, [_vm._v("\n    Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "paysuc-div-img",
    attrs: {
      "src": require("../../static/images/大成功.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span-paysuc-css"
  }, [_vm._v("订单支付成功")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-345cc33e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/paySuccess.vue
// module id = 326
// module chunks = 2